/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { styled } from 'styled-components';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

const MainContainer = styled.div`
  width: 100%;
  margin: 10px auto;
  @media (max-width: 767px) {
    width: 100%;
    margin: 0;
  }
`;

const Form10BETable = ({ data, headers }) => {
  return (
    <MainContainer>
      <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
        <Table>
          <TableHead>
            <TableRow style={{ background: '#e3f0ff' }}>
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{ borderRight: '1px solid #ddd', fontWeight: 'bold' }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? '#f4f4f4' : '#ffffff' }}
              >
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column1}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column2}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column3}
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ddd' }}>
                  {row.column4}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MainContainer>
  );
};
Form10BETable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Form10BETable;
